import { PhosphorCaretRightAnchor } from "components/Atoms/PhosphorIconAnchor";
import { PhosphorCaretRightButton } from "components/Atoms/PhosphorIconButton";
import React from "react";

interface Props {
  url: string | undefined
}

const ArrowRight = ({ url }: Props) => {
  if (url) {
    return <PhosphorCaretRightAnchor
      layout="in-square"
      href={url} />;
  }

  return <PhosphorCaretRightButton
    layout="in-square"
    disabled={true} />;
};

export default ArrowRight;
